import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './components/Shared/locales/en/translation.json';
import translationDE from './components/Shared/locales/de/translation.json';

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // 👈 Always use German
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: [], // 👈 Disable all detection
      caches: [], // 👈 Disable all caching
    },
    debug: false,
  });

// 👇 Extra guarantee: Forcefully change language to 'de'
if (typeof window !== 'undefined') {
  localStorage.removeItem('i18nextLng'); // Remove any stored language
  i18n.changeLanguage('de');
}

export default i18n;
